import Loader from "../reusble_components/loader";
import { useStores } from "../../store/index";
import { CiSearch } from "react-icons/ci";
import Create from "../dashboard/create";
import TopicBasedInterview from "../dashboard/topicBasedInterview";
import { useObserver } from "mobx-react";
import { MeetingCreationForm } from "../dashboard/dashboard";
import { AiOutlineExport } from "react-icons/ai";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Moment from "react-moment";
import {
  MdAddCircleOutline,
  MdContentCopy,
  MdOutlineWarningAmber,
} from "react-icons/md";
import { RefreshButton } from "../reusble_components/buttons/outLinedIconButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import HelpCenter from "../reusble_components/helpCenter";
import { getDomainForWhiteLabeling } from "../../services/white_label";

export default function InterviewsList() {
  const { RecuiterStore, PopupStore, CompanyInterviewsStore, InterviewStore } =
    useStores();
  const [tableData, setTableData] = useState(false);

  useEffect(() => {
    RecuiterStore.getallApplicantsData();
    RecuiterStore.fetchCompanyInvitations();
  }, []);

  // fake date for coloumndefs and rowdata
  function image(props) {
    return <img src={props.value} className="h-10 w-10 rounded-full mx-auto" />;
  }
  function date(props) {
    return <Moment format="MMMM D, YYYY">{props.value}</Moment>;
  }

  const scrollToTop = () => {
    // scroll to top by id
    try {
      const element = document.getElementById("mobile-header");
      element.scrollIntoView({ behavior: "instant" });
    } catch (error) {}
  };

  const gridOptions = {
    // ... other grid options
    // Set the row height automatically based on content
    rowHeight: 50, // You can also set a fixed row height if needed
    // ... other grid options
  };

  const columnDefs = [
    { headerName: "SN", field: "sn", width: 80, filter: "agTextColumnFilter" },
    {
      headerName: "Pic",
      field: "Pic",
      width: 80,
      filter: "agTextColumnFilter",
      cellRenderer: image,
      cellStyle: { marginTop: "4px" },
    },
    {
      headerName: "Name",
      field: "Name",
      width: 150,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Technology",
      field: "Technology",
      width: 150,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Score",
      field: "Score",
      width: 90,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Mail",
      field: "Mail",
      width: 300,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Mobile",
      field: "Mobile",
      width: 150,
      filter: "agTextColumnFilter",
    },
    // {
    //   headerName: "College",
    //   field: "College",
    //   width: 150,
    //   filter: "agTextColumnFilter",
    // },
    // {
    //   headerName: "Status",
    //   field: "Status",
    //   width: 150,
    //   filter: "agTextColumnFilter",
    // },
    {
      headerName: "Date",
      field: "Date",
      width: 200,
      filter: "agTextColumnFilter",
      cellRenderer: date,
    },
    {
      headerName: "Resume",
      field: "ResumeLink",
      width: 200,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Recorded Video",
      field: "RecordedVideoLink",
      width: 200,
      filter: "agTextColumnFilter",
    },
  ];

  const navigate = useNavigate();

  const interviewScore = (resultArray) => {
    try {
      //   return resultArray[0]?.score + "%";

      // return result array that contains ""average_technical_score" and resultArray is an array of objects
      const course = resultArray.filter(
        (item) => item.name === "average_technical_score",
      );

      return course[0].score + "%";
    } catch (error) {
      return "N/A";
    }
  };

  const exportToExcel = () => {
    const data = RecuiterStore.filteredApplicants.map((data, index) => {
      // Convert the 13-digit timestamp to a date
      const createdAtDate = new Date(data?.createdAt);

      return {
        sn: index + 1,
        // Pic: data?.interviewee?.pic,
        Name: data?.interviewee?.name,
        Mail: data?.interviewee?.mail,
        Mobile: data?.interviewee?.mobile,
        Technology: data?.technology !== "" ? data?.technology : data?.role,
        noOfQuestions: data?.noOfQuestions,
        Score: interviewScore(data?.result),
        Date: createdAtDate.toLocaleDateString("en-GB"), // Format as 'd-m-y'
        id: data?._id,
        ResumeLink: data?.resumeLink
          ? data?.resumeLink
          : "Resume is not uploaded",
        RecordedVideoLink: data?.recording
          ? data?.recording
          : "Video is not recorded",
      };
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "InterviewResponses");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "InterviewResponses.xlsx");
  };

  return useObserver(() => (
    <>
      <HelpCenter />
      <Loader loader={RecuiterStore.loader} />
      {PopupStore.topicbasedinterview && (
        <TopicBasedInterview
          popUpInitialValue={PopupStore.topicbasedinterview}
          handlePopup={() => {
            PopupStore.setTopicBasedInterview(false);
          }}
        />
      )}
      {PopupStore.createinterview && (
        <Create
          popUpInitialValue={PopupStore.createinterview}
          handlePopup={() => {
            PopupStore.setCreateInterview(false);
          }}
        />
      )}
      <div className="w-full  items-center flex flex-col bg-bg2 min-h-[100vh] h-[100%] pb-5 gil-reg mt-10">
        <h1 className="text-4xl font-bold text-primary block md:hidden lg:hidden mb-4">
          Interviews
        </h1>
        <Loader loader={RecuiterStore.loader} />
        <div className="flex md:flex-row lg:flex-row flex-row items-center justify-between w-[90%] mx-auto  ">
          {/* <img src={logo} className=" md:w-52 lg:wi52 w-[50%] " /> */}
          <div className="bg-white relative md:w-[65%] lg:w-[65%] w-[85%] h-16 flex justify-between px-7 items-center rounded-full">
            <form
              className="flex w-full"
              onSubmit={(e) => {
                e.preventDefault();
                RecuiterStore.searchApplicationByNameOrTechnology();
                // RecuiterStore.searchUsers()
              }}
            >
              <div className="flex justify-start items-center w-full ">
                <input
                  value={RecuiterStore.search}
                  type="text"
                  placeholder="Search by Name, Role or Technology"
                  // ref={searchValue}
                  onChange={(e) => {
                    RecuiterStore.setSearching(e.target.value);
                    if (e.target.value.length === 0) {
                      RecuiterStore.showAllApplicants();
                    }
                  }}
                  className=" placeholder-primary truncate text-lg outline-none h-10 w-[88%] md:w-[95%]"
                />
                <CiSearch
                  onClick={RecuiterStore.searchApplicationByNameOrTechnology}
                  className="text-4xl text-primary absolute right-4 md:right-8"
                />
              </div>
            </form>
          </div>

          <div className="md:hidden lg:hidden block">
            {" "}
            <MdAddCircleOutline
              size="2.5rem"
              onClick={() => {
                PopupStore.setCompanyInterview(true);
                // PopupStore.setCreateInterview(true);
                navigate("/company/interview");
              }}
              className="text-primary"
            />
            {/* <MeetingCreationForm  /> */}
          </div>
          <div
            className="md:w-[25%]  lg:w-[25%] w-[90%] -mt-2 hidden md:block lg:block"
            onClick={() => {
              PopupStore.setCompanyInterview(true);
              InterviewStore.setCompanyInterview(true);
              console.log("setted");
            }}
          >
            <MeetingCreationForm fromCompany={true} />
          </div>
        </div>

        <p className="text-text_warningColor font-semibold flex items-center gap-2 mt-5 text-xl">
          <MdOutlineWarningAmber />
          This page will be removed in few days. Please use the History page for
          viewing your activities.
        </p>

        <div
          className="ag-theme-alpine "
          style={{
            height: 600,
            width: "100%",
            marginTop: "50px",
            display: "flex",
            marginLeft: "auto",
          }}
        >
          <div
            className={`md:flex-col gil-reg lg:flex-col md:w-[60%] lg:w-[60%] w-[90%] mx-auto md:flex lg:flex ${
              tableData ? "block" : "hidden"
            }`}
          >
            <div className="flex flex-row justify-between items-center w-full mb-4">
              <p className="text-xl md:text-3xl">All Interview Responses</p>
              <div className="flex">
                <button
                  className="flex gap-2 items-center p-2 border border-primary text-primary rounded-2xl hover:bg-primary hover:text-white focus:outline-none mr-[20px]"
                  onClick={exportToExcel}
                >
                  <AiOutlineExport /> <span>Export</span>
                </button>
                {RecuiterStore.selectedInvitationId == null ? (
                  <RefreshButton
                    buttonName="Refresh"
                    onClick={() => RecuiterStore.getallApplicantsData(true)}
                  />
                ) : (
                  <RefreshButton
                    onClick={RecuiterStore.showAllApplicants}
                    buttonName="Show All"
                  />
                )}
              </div>
            </div>
          </div>
          <div
            className={`md:w-[27%] mx-auto lg:w-[27%] w-[90%] gil-reg ${
              window.innerWidth < 768 && tableData ? "hidden" : "block"
            } overflow-x-hidden overflow-y-auto no-scrollbar`}
          >
            <div className="flex flex-row justify-between items-center w-full">
              <p className="text-2xl ">Invitations overview</p>

              <RefreshButton
                onClick={() => RecuiterStore.fetchCompanyInvitations(true)}
                buttonName="Refresh"
              />
            </div>
            {RecuiterStore.companyInvitations.map((list, index) => (
              <div
                key={index}
                onClick={() => {
                  if (window.innerWidth < 768) {
                    setTableData(true);
                  }
                }}
              >
                <InvitationCard
                  array={RecuiterStore.companyInvitations}
                  item={list}
                  index={index}
                  technology={list.technology}
                  level={list?.levelOfInterview}
                  createdAt={list.createdAt}
                  noOfQuestions={list.noOfQuestions}
                  result={list.result}
                />
              </div>
            ))}
          </div>
        </div>

        {/* <Create popUpInitialValue={true} position="/company/interviews" /> */}
      </div>
    </>
  ));
}

export function InvitationCard({
  array,
  item,
  index,
  technology,
  level,
  createdAt,
  noOfQuestions,
  result,
}) {
  const { RecuiterStore } = useStores();

  const id = item?._id;
  const domain = getDomainForWhiteLabeling();
  const interviewLink =
    domain === "app.reaidy.io"
      ? `https://user.reaidy.io/interview-creation/11?meetingid=${id}`
      : `https://app.reaidy.io/share?page=interview_invitation&id=${id}`;

  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = interviewLink;

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
    window.alert("link copied");
  };

  const timeStampToDate = (timestamp) => {
    const date = new Date(timestamp);
    const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
    const fullDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return `${fullDate}`;
  };

  const getCompletedInterviewCount = (interviews) => {
    let count = 0;
    interviews.forEach((interview) => {
      if (interview?.isInterviewCompleted) {
        count++;
      }
    });
    return count;
  };
  const getResultInterviewCount = (interviews) => {
    let count = 0;
    interviews.forEach((interview) => {
      if (interview?.isResultPublished) {
        count++;
      }
    });
    return count;
  };

  const filterApplications = () => {
    RecuiterStore.filterApplicantsByInvitationId(id);
  };

  return (
    <div
      onClick={filterApplications}
      className={`cursor-pointer w-full hover:border hover:border-primary flex  p-[15px] h-fit min-h-[200px] bg-white rounded-[10px] mt-[17px] gap-2 ${
        id === RecuiterStore.selectedInvitationId && "border border-primary"
      }`}
    >
      <span className=" flex flex-row pt-5 px-3 ">
        {array?.length - index < 10 ? (
          <h1 className="text-[20px]  bg-gray-200 h-10 text-text_color3 border border-1  rounded-md px-3 mb-auto py-1">
            0{array?.length - index}
          </h1>
        ) : (
          <h1 className="text-[20px] my-1 bg-gray-200 h-10 text-text_color3 border border-1  rounded-md px-3 mb-auto py-1">
            {array?.length - index}
          </h1>
        )}
      </span>
      <div className="flex flex-col items-start pt-4 ml-5">
        <div className="flex flex-col text-start  ">
          <p className=" text-[17.52px] my-auto  text-text_color3">
            Topic: {technology}
          </p>
          <div className="flex flex-row ">
            <p className=" text-[17.52px] my-auto text-primary ">
              <span className=" text-text_color3 ">Level:</span> {level}
            </p>
            <p className="mx-auto my-auto text-xs text-text_color3 opacity-50 px-3 ">
              {timeStampToDate(createdAt)}
            </p>
          </div>
          <h1 className="text-[17px] my-auto text-text_color3 rounded-md py-1">
            Questions: {noOfQuestions}
          </h1>
        </div>
        <div className="flex flex-row justify-between w-full text-xs p-1  text-black  ">
          <div className="">
            <p className=" gil-med text-lg ">{item?.interviews?.length}</p>
            <p className="text-[10px] opacity-70">Invited</p>
          </div>
          <div className="">
            <p className="text-lg gil-med">
              {getCompletedInterviewCount(item?.interviews)}
            </p>
            <p className="text-[10px] opacity-70">Completed</p>
          </div>
          <div className="">
            <p className="text-lg gil-med">
              {getResultInterviewCount(item?.interviews)}
            </p>
            <p className="text-[10px] opacity-70">Results</p>
          </div>
        </div>
        <button
          onClick={handleCopyClick}
          className="cursor-pointer text-right text-gray-500 hover:text-primary my-auto flex items-center text-sm justify-start w-full "
        >
          {" "}
          <span>Invite Link</span>{" "}
          <MdContentCopy className=" mx-1 hover:text-primary " />
        </button>
      </div>
    </div>
  );
}
